// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#stock-container {
  padding: 24px;
}
#stock-container .title {
  color: var(--text-Ttulos, #0D253A);
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 18px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-top: 0px;
}
#stock-container .detail {
  color: var(--text-BODY, #2C4051);
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.custom-form-stock {
  background: transparent;
}
.custom-form-stock ion-toggle {
  --background: #dfdfdf !important;
  --background-checked: var(--ion-color-success) !important;
  --handle-background: #ffffff !important;
  --handle-background-checked: #fff !important;
}
.custom-form-stock .item-check-control {
  --padding-start: 0px;
  --padding-end: 0px;
  --background: transparent;
}
.custom-form-stock .item-check-control ion-label {
  color: var(--text-Subttulos, #0D253A);
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Poppins";
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
.custom-form-stock .custom-item-form ::ng-deep .required-indicator .label-text::after {
  content: "*";
  transform: translate(-100%, 0);
  color: red !important;
  padding-left: 5px;
}
.custom-form-stock .custom-item-form ::ng-deep .custom-input .label-text {
  color: #0D253A !important;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Roboto";
  font-size: 16px !important;
}
.custom-form-stock .custom-item-form ::ng-deep .custom-input {
  color: #0D253A !important;
  font-family: "Poppins";
  font-size: 16px !important;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 0px;
  bottom: 2px;
}
.custom-form-stock .custom-item-form {
  border: 2px solid #ede9e9;
  margin-bottom: 16px;
  min-height: 56px;
  background: white;
  border-radius: 16px;
  height: 56px;
  --padding-start: 16px;
  --padding-end: 16px;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/store/components/categories/shipping-control/shipping-control.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;AACE;EACE,kCAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AACJ;AAEE;EACE,gCAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAAJ;;AAIA;EACE,uBAAA;AADF;AAGE;EACE,gCAAA;EACA,yDAAA;EACA,uCAAA;EACA,4CAAA;AADJ;AAIE;EACE,oBAAA;EACA,kBAAA;EACA,yBAAA;AAFJ;AAII;EACE,qCAAA;EACA,6CAAA;EACA,sBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAFN;AAQI;EACE,YAAA;EACA,8BAAA;EACA,qBAAA;EACA,iBAAA;AANN;AASI;EACE,yBAAA;EACA,6CAAA;EACA,qBAAA;EACA,0BAAA;AAPN;AAUI;EACE,yBAAA;EACA,sBAAA;EACA,0BAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,WAAA;AARN;AAaE;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;EACA,qBAAA;EACA,mBAAA;AAXJ","sourcesContent":["#stock-container {\n  padding: 24px;\n\n  .title {\n    color: var(--text-Ttulos, #0D253A);\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-family: 'Poppins';\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 600;\n    line-height: normal;\n    margin-top: 0px;\n  }\n\n  .detail {\n    color: var(--text-BODY, #2C4051);\n    font-feature-settings: 'liga' off, 'clig' off;\n    font-family: 'Poppins';\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: normal;\n  }\n}\n\n.custom-form-stock {\n  background: transparent;\n\n  ion-toggle {\n    --background: #dfdfdf !important;\n    --background-checked: var(--ion-color-success) !important;\n    --handle-background: #ffffff !important;\n    --handle-background-checked: #fff !important;\n  }\n\n  .item-check-control {\n    --padding-start: 0px;\n    --padding-end: 0px;\n    --background: transparent;\n\n    ion-label {\n      color: var(--text-Subttulos, #0D253A);\n      font-feature-settings: 'liga' off, 'clig' off;\n      font-family: 'Poppins';\n      font-size: 16px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: normal;\n    }\n  }\n\n\n  .custom-item-form {\n    ::ng-deep .required-indicator .label-text::after {\n      content: '*';\n      transform: translate(-100%, 0);\n      color: red !important;\n      padding-left: 5px;\n    }\n\n    ::ng-deep .custom-input .label-text {\n      color: #0D253A !important;\n      font-feature-settings: \"liga\" off, \"clig\" off;\n      font-family: \"Roboto\";\n      font-size: 16px !important;\n    }\n\n    ::ng-deep .custom-input {\n      color: #0D253A !important;\n      font-family: \"Poppins\";\n      font-size: 16px !important;\n      font-style: normal;\n      font-weight: 400;\n      line-height: normal;\n      margin-bottom: 0px;\n      bottom: 2px;\n    }\n\n  }\n\n  .custom-item-form {\n    border: 2px solid #ede9e9;\n    margin-bottom: 16px;\n    min-height: 56px;\n    background: white;\n    border-radius: 16px;\n    height: 56px;\n    --padding-start: 16px;\n    --padding-end: 16px;\n\n  } \n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
